// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentRequestModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentRequestModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentRequestModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentRequestModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentRequestModel.attributeTypeMap = [
    {
        "name": "caseKey",
        "baseName": "caseKey",
        "type": "string"
    },
    {
        "name": "hubEnrollment",
        "baseName": "hubEnrollment",
        "type": "CoverMyMedsInboundEnrollmentHubEnrollmentModel"
    },
    {
        "name": "workflow",
        "baseName": "workflow",
        "type": "CoverMyMedsInboundEnrollmentWorkflowModel"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentRequestModel.js.map